/** Song switch errors (POST /bands/{id}/queue/entries/{entryId}/switch) with their own message (ENG-684); anything else is generic. */
export const SWITCH_ERRORS = {
  switch_locked: 'publicSongList.switch.errors.locked',
  switch_not_queued: 'publicSongList.switch.errors.notQueued',
  switch_not_found: 'publicSongList.switch.errors.notQueued',
  switch_same_song: 'publicSongList.switch.errors.sameSong',
  song_played_this_stream: 'publicSongList.switch.errors.playedTonight',
  song_not_requestable: 'publicSongList.switch.errors.notRequestable',
  switch_rate_limited: 'publicSongList.switch.errors.tooSoon',
  show_not_live: 'publicSongList.switch.errors.closed',
  requests_closed: 'publicSongList.switch.errors.closed',
};
